import { shopScene } from '../shopkit.js';

/** 废品收购站：破烂的归宿。 */
export const junkyardDoc = shopScene({
  id: 'junkyard',
  name: '废品收购站',
  shop: 'junkyard',
  owner: '收破烂的老汉',
  desc: '一杆大秤挂在梁下，院里堆成分区的破烂。',
  w: 26, h: 20,
  floor: ':',
  counters: [{ gx: 10, gy: 3, len: 5, kind: 'junkyard' }],
  props: [
    { type: 'junkyard_scale', gx: 9, gy: 7 },
    { type: 'scrap_heap', gx: 4, gy: 12 },
    { type: 'scrap_heap', gx: 5, gy: 12 },
    { type: 'oil_drum_unlabeled', gx: 19, gy: 13 },
    { type: 'waste_bin', gx: 3, gy: 16 },
    { type: 'lot_bucket', gx: 21, gy: 9 },
  ],
  portals: [
    { to: 'fun_street', gx: 13, gy: 19, spawn: [36, 10], label: '回瓦舍街' },
  ],
});

export default junkyardDoc;
